module.exports = __webpack_public_path__ + "img/user-config.6d40809f.svg";